<app-choose-plan-generic
  [currentPlan]="currentPlan"
  (payRecurrenceChange)="paymentRecurrence = $event"
  (planCardBtnClick)="handlePlanCardBtnClick($event)"
  [isV2]="isV2"
  [useCardEntryExperimentTitle]="useCardEntryExperimentTitle"
  [ngClass]="{ 'v2': isV2 }">
</app-choose-plan-generic>
